/* SK Tarvikekategoria — client-side search, tag filter & sort */
(function () {
  function init(root) {
    if (root.dataset.acatReady) return;
    root.dataset.acatReady = '1';

    var grid = root.querySelector('[data-acat-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-acat-card]'));
    var searchEl = root.querySelector('[data-acat-search]');
    var sortEl = root.querySelector('[data-acat-sort]');
    var countEl = root.querySelector('[data-acat-count]');
    var noResults = root.querySelector('[data-acat-noresults]');
    var chipWrap = root.querySelector('[data-acat-chips]');
    var chips = chipWrap ? Array.prototype.slice.call(chipWrap.querySelectorAll('[data-acat-filter]')) : [];

    var activeFilter = 'all';
    var query = '';

    function plural(n) { return n === 1 ? '1 tuote' : n + ' tuotetta'; }

    function apply() {
      var shown = 0;
      cards.forEach(function (card) {
        var name = card.getAttribute('data-name') || '';
        var vendor = card.getAttribute('data-vendor') || '';
        var tags = card.getAttribute('data-tags') || '';
        var matchQuery = !query || name.indexOf(query) !== -1 || vendor.indexOf(query) !== -1;
        var matchFilter = activeFilter === 'all' || tags.split(',').indexOf(activeFilter) !== -1;
        if (matchQuery && matchFilter) {
          card.style.display = '';
          shown++;
        } else {
          card.style.display = 'none';
        }
      });
      if (countEl) countEl.textContent = plural(shown);
      if (noResults) noResults.hidden = shown !== 0;
    }

    function sortCards(mode) {
      var visible = cards.slice();
      visible.sort(function (a, b) {
        if (mode === 'price-asc') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        if (mode === 'price-desc') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        if (mode === 'name-asc') return (a.dataset.name || '').localeCompare(b.dataset.name || '', 'fi');
        return parseInt(a.dataset.index, 10) - parseInt(b.dataset.index, 10);
      });
      visible.forEach(function (c) { grid.appendChild(c); });
    }

    if (searchEl) {
      searchEl.addEventListener('input', function () {
        query = (searchEl.value || '').trim().toLowerCase();
        apply();
      });
    }
    if (sortEl) {
      sortEl.addEventListener('change', function () {
        sortCards(sortEl.value);
        apply();
      });
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        activeFilter = chip.getAttribute('data-acat-filter') || 'all';
        apply();
      });
    });

    apply();
  }

  function boot() {
    document.querySelectorAll('[data-sk-acat]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Theme editor re-render support
  document.addEventListener('shopify:section:load', boot);
})();
